export default class Config {
  public static baseApiUrl = 'https://clients-api.priorhq.com';
}
